<template>
  <v-layout>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <!--sale stats begin-->
        <v-flex xs12 sm4>
          <v-card>
            <v-card-title
              primary-title
              style="background: darkgreen; color: white"
            >
              <div>
                <h4 class="headline mb-0">Today's Transactions</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background: darkgreen; color: white">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">swap_horizontal</v-icon>
                </v-flex>

                <v-flex xs8>{{
                  Number(other_vals.tot_sales_today).toLocaleString()
                }}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Number of Transactions Done Today</p>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-card-title
              primary-title
              style="background: darkgoldenrod; color: white"
            >
              <div>
                <h4 class="headline mb-0">All Transactions</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background: darkgoldenrod; color: white">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">receipt</v-icon>
                </v-flex>

                <v-flex xs8>{{
                  Number(other_vals.all_time_trans_count).toLocaleString()
                }}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>All Time Total Transactions</p>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-card-title
              primary-title
              style="background: darkblue; color: white"
            >
              <div>
                <h4 class="headline mb-0">Items</h4>
              </div>
            </v-card-title>
            <!--<v-divider></v-divider>-->
            <v-card-text style="background: darkblue; color: white">
              <v-layout row wrap class="stat-data">
                <v-flex xs4>
                  <v-icon style="color: white">list</v-icon>
                </v-flex>

                <v-flex xs8>{{
                  Number(other_vals.total_stock_items).toLocaleString()
                }}</v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <p>Total Items In Stock</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <!--sale stats end-->

      <!--charts begin-->
      <v-layout row wrap style="margin-top: 10px; margin-bottom: 5px">
        <v-flex xs12 sm8>
          <v-card>
            <v-progress-linear
              indeterminate
              color="cyan"
              height="3"
              v-if="loading"
            ></v-progress-linear>
            <v-card-title primary-title>
              <div>
                <h4 class="headline mb-0">Earnings {{ selected_year }}</h4>
              </div>
            </v-card-title>
            <v-card-text>
              <SaleBarChart
                :chartdata="bar_chart_data"
                :height="chart_height"
                :key="chart_refresh_key"
              ></SaleBarChart>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-card-text>
              <!--account year card-->
              <v-card class="elevation-5">
                <v-card-text>
                  <p>Select Account Year</p>
                  <select
                    v-model="selected_year"
                    style="
                      border: 1px solid lightgray;
                      width: 100%;
                      cursor: pointer;
                    "
                  >
                    <option
                      v-for="(o, idx) in years"
                      :value="o"
                      v-bind:key="idx"
                    >
                      {{ o }}
                    </option>
                  </select>
                </v-card-text>
              </v-card>
              <!--account year card ends-->

              <!--payments piechart card-->
              <v-card style="margin-top: 5px">
                <v-card-text style="padding: 5px">
                  <PaymentModePieChart
                    :chartdata="pie_chart_data"
                    :height="chart_height"
                    :key="chart_refresh_key"
                  ></PaymentModePieChart>
                  <p>Payment Methods (%) {{ selected_year }}</p>
                </v-card-text>
              </v-card>
              <!--payments piechart card end-->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!--charts end-->

      <!--stat cards start (Earnings)-->

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-card>
            <v-card-title style="background: lightgreen">
              <h4>HIGH IN DEMAND</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="earning_headers.qt"
                :items="other_vals.high_demand"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.sales_count="{ item }">
                  {{ Number(item.sales_count).toLocaleString() }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm3>
          <v-card>
            <v-card-title style="background: lightpink">
              <h4>LOW IN DEMAND</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="earning_headers.qt"
                :items="other_vals.low_demand"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.sales_count="{ item }">
                  {{ Number(item.sales_count).toLocaleString() }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm3>
          <v-card>
            <v-card-title style="background: lightgreen">
              <h4>HIGHEST EARNING</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="earning_headers.en"
                :items="other_vals.high_earning"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.sale_sum="{ item }">
                  {{ parseFloat(item.sale_sum) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm3>
          <v-card>
            <v-card-title style="background: lightpink">
              <h4>LOWEST EARNING</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="earning_headers.en"
                :items="other_vals.low_earning"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.sale_sum="{ item }">
                  {{ parseFloat(item.sale_sum) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!--stat cards end-->

      <!--stat cards start (Transactions)-->

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-title class="trans-head">
              <h4>Daily Transactions</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="trans_headers.dly_trans"
                :items="other_vals.daily_trans"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.qty_sold="{ item }">
                  {{ Number(item.qty_sold).toLocaleString() }}
                </template>

                <template v-slot:item.total_trans="{ item }">
                  {{ Number(item.total_trans).toLocaleString() }}
                </template>

                <template v-slot:item.ttl_earned="{ item }">
                  {{ parseFloat(item.ttl_earned) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6>
          <v-card>
            <v-card-title class="trans-head">
              <h4>Transactions by Days</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="trans_headers.trans_by_day"
                :items="other_vals.trans_by_days"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <template v-slot:item.salesDay="{ item }">
                  {{ dayNames[item.salesDay] }}
                </template>
                <template v-slot:item.qty_sold="{ item }">
                  {{ Number(item.qty_sold).toLocaleString() }}
                </template>
                <template v-slot:item.total_trans="{ item }">
                  {{ Number(item.total_trans).toLocaleString() }}
                </template>
                <template v-slot:item.ttl_earned="{ item }">
                  {{ parseFloat(item.ttl_earned) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!--stat cards end-->

      <!--stat cards start (Transactions2)-->

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-title class="trans-head">
              <h4>Transactions By Months</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="trans_headers.mth_trans"
                :items="other_vals.trans_by_months"
                class="elevation-0"
                hide-default-footer
                :items-per-page="12"
                :loading="loading"
              >
                <!-- <template v-slot:items="props">
                  <td>{{ monthNames[props.item.salesMonth] }}</td>
                  <td>{{ props.item.qty_sold }}</td>
                  <td>{{ props.item.total_trans }}</td>
                  <td class="text-xs-right">
                    {{ props.item.ttl_earned | currency }}
                  </td>
                </template> -->

                <template v-slot:item.salesMonth="{ item }">
                  {{ monthNames[item.salesMonth] }}
                </template>
                <template v-slot:item.qty_sold="{ item }">
                  {{ Number(item.qty_sold).toLocaleString() }}
                </template>
                <template v-slot:item.total_trans="{ item }">
                  {{ Number(item.total_trans).toLocaleString() }}
                </template>
                <template v-slot:item.ttl_earned="{ item }">
                  {{ parseFloat(item.ttl_earned) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6>
          <v-card>
            <v-card-title class="trans-head">
              <h4>Transactions by Years</h4>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="trans_headers.yr_trans"
                :items="other_vals.trans_by_years"
                class="elevation-0"
                hide-default-footer
                :loading="loading"
              >
                <!-- <template v-slot:items="props">
                  <td>{{ props.item.salesYear }}</td>
                  <td>{{ props.item.qty_sold }}</td>
                  <td>{{ props.item.total_trans }}</td>
                  <td class="text-xs-right">
                    {{ props.item.ttl_earned | currency }}
                  </td>
                </template> -->

                <template v-slot:item.salesYear="{ item }">
                  {{ item.salesYear }}
                </template>
                <template v-slot:item.qty_sold="{ item }">
                  {{ Number(item.qty_sold).toLocaleString() }}
                </template>
                <template v-slot:item.total_trans="{ item }">
                  {{ Number(item.total_trans).toLocaleString() }}
                </template>
                <template v-slot:item.ttl_earned="{ item }">
                  {{ parseFloat(item.ttl_earned) | currency }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!--stat cards end-->
    </v-container>
  </v-layout>
</template>
<style>
.stat-data {
  font-size: 40px;
}

.stat-data .v-icon {
  font-size: 40px;
}

.v-card__title {
  background: #fbfbfb;
}

.trans-head {
  background: #333;
  color: #fff;
}
</style>
<script>
import SaleBarChart from "../../utils/charts/barchart";
import PaymentModePieChart from "../../utils/charts/piechart";
import { mapGetters } from "vuex";

export default {
  components: {
    SaleBarChart,
    PaymentModePieChart,
  },
  data: () => ({
    chart_refresh_key: 0,
    all_set: 0,
    chart_height: 300, //chart height to apply to all charts
    earning_headers: {
      //for v-datatable
      qt: [
        {
          text: "Item",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Qty Sold",
          align: "center",
          sortable: false,
          value: "sales_count",
        },
      ], //for quantities demands
      en: [
        {
          text: "Item",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Tot. Earned",
          align: "center",
          sortable: false,
          value: "sale_sum",
        },
      ], //for earnings
    },
    trans_headers: {
      //for transactions stats tbls

      dly_trans: [
        {
          text: "Day",
          align: "Enter",
          sortable: false,
          value: "salesDate",
        },
        {
          text: "Qty Sold",
          align: "center",
          sortable: false,
          value: "qty_sold",
        },
        {
          text: "Tot. Trans.",
          align: "center",
          sortable: false,
          value: "total_trans",
        },
        {
          text: "Tot. Earned",
          align: "center",
          sortable: false,
          value: "ttl_earned",
        },
      ],
      trans_by_day: [
        {
          text: "Day",
          align: "Enter",
          sortable: false,
          value: "salesDay",
        },
        {
          text: "Qty Sold",
          align: "center",
          sortable: false,
          value: "qty_sold",
        },
        {
          text: "Tot. Trans.",
          align: "center",
          sortable: false,
          value: "total_trans",
        },
        {
          text: "Tot. Earned",
          align: "center",
          sortable: false,
          value: "ttl_earned",
        },
      ],
      mth_trans: [
        {
          text: "Month",
          align: "Enter",
          sortable: false,
          value: "salesMonth",
        },
        {
          text: "Qty Sold",
          align: "center",
          sortable: false,
          value: "qty_sold",
        },
        {
          text: "Tot. Trans.",
          align: "center",
          sortable: false,
          value: "total_trans",
        },
        {
          text: "Tot. Earned",
          align: "center",
          sortable: false,
          value: "ttl_earned",
        },
      ],

      yr_trans: [
        {
          text: "Year",
          align: "Enter",
          sortable: false,
          value: "salesYear",
        },
        {
          text: "Qty Sold",
          align: "center",
          sortable: false,
          value: "qty_sold",
        },
        {
          text: "Tot. Trans.",
          align: "center",
          sortable: false,
          value: "total_trans",
        },
        {
          text: "Tot. Earned",
          align: "center",
          sortable: false,
          value: "ttl_earned",
        },
      ],
    },
    bar_chart_data: {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          label: "Monthly Sales (GHS)",
          backgroundColor: "#3c8dbc",
          data: [],
        },
        {
          label: "Monthly Profits on Sales (GHS)",
          backgroundColor: "darkgreen",
          data: [],
        },
      ],
    },
    pie_chart_data: {
      labels: ["Cash", "Credit"],
      datasets: [
        {
          label: "Payment Methods",
          backgroundColor: ["#41B883", "#E46651"],
          data: [100, 0],
        },
      ],
    },

    years: [],
    selected_year: "",
    selected_year_monthly_data: [],
    stat_model: {},
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  }),
  mounted() {
    let currYear = new Date().getFullYear();
    let yrsArr = [];

    for (var i = currYear; i > currYear - 20; i--) {
      yrsArr.push(i);
    }

    this.years = yrsArr;
  },
  created() {
    //console.log(this.$store.getters.layout)
    this.$store.dispatch("AdminDash/set_loading", true);
    this.$store.dispatch("Items/getAll");
    this.$store.dispatch("Sales/getAll");
  },
  methods: {
    loadSelectedYearStats() {
      //setting chart values to current value in store
      var b = this.chart_vals.barChartVals;
      var p = this.chart_vals.pieChartVals;

      this.bar_chart_data.datasets[0].data = b.sales; //setting sales values for sales bars
      this.bar_chart_data.datasets[1].data = b.profits; //setting profits values for profit bars

      this.pie_chart_data.datasets[0].data = p; //setting mode of payment piechart values

      this.chart_refresh_key = this.chart_refresh_key + 1;
      // console.log(this.bar_chart_data.datasets[0].data)
    },
  },
  computed: {
    ...mapGetters({
      stock_items: "Items/ITEMS",
      sales: "Sales/SALES",
      sales_items: "Sales/SALES_ITEMS",
      errors: "Sales/SALE_ERROR",
      loading: "AdminDash/DASH_LOADING",
      chart_vals: "AdminDash/CHARTVALS",
      other_vals: "AdminDash/OTHERVALS",
    }),
  },
  watch: {
    stock_items() {
      //console.log("STOCK ITEMS", this.stock_items);
      //this.$store.dispatch("AdminDash/set_othervals",{})
      this.all_set = this.all_set + 1;
    },
    sales() {
      //this.refresh_key = this.refresh_key + 1;
      //console.log("SALES", this.sales);
      this.all_set = this.all_set + 1;
      this.selected_year = new Date().getFullYear();
    },
    sales_items() {
      //console.log("SALE ITEMS",this.sales_items)
      this.all_set = this.all_set + 1;
    },
    all_set(val) {
      if (val >= 3) {
        this.$store.dispatch("AdminDash/set_othervals", {
          sales: this.sales,
          stock_items: this.stock_items,
          sales_items: this.sales_items,
        }); //only set stats after all is set or all data is loaded
        this.$store.dispatch("AdminDash/set_loading", false);
        //console.log("OTHER_VALS",this.other_vals)
      }
    },
    selected_year(val) {
      this.$store.dispatch("AdminDash/set_year", val);
      this.$store.dispatch("AdminDash/set_chartvals", { sales: this.sales }); //setting up stats in store
    },
    chart_vals() {
      this.loadSelectedYearStats(); //loading stats from store to display on screen
    },
  },
};
</script>